/** import external dependencies */
import $ from 'jquery/dist/jquery.js';
import "waypoints/lib/jquery.waypoints.min";
import 'jquery-validation/dist/jquery.validate';
import "jquery-ui/ui/core";
import "jquery-ui/ui/widget";
import "jquery-ui/ui/widgets/datepicker";
import "prcomboselect";
import "jquery-accessible-modal-window-aria";
import "objectFitPolyfill";
import * as moment from "moment";

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import pageTemplateTemplateHome from './routes/home';
import pageTemplateTemplateAbout from "./routes/about";
import singleStop from "./routes/stop";
import pageTemplateTemplateServices from './routes/services';
import pageTemplateTemplateSchedule from './routes/schedule';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	pageTemplateTemplateHome,
	pageTemplateTemplateAbout,
	pageTemplateTemplateServices,
	pageTemplateTemplateSchedule,
	singleStop,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());


// WEBPACK FOOTER //
// ./scripts/main.js